// extracted by mini-css-extract-plugin
module.exports = {"container":"e_B1","tabList":"e_C1"};